import { render, staticRenderFns } from "./SelecionarProprietarioDialog.vue?vue&type=template&id=7c01205a&"
import script from "./SelecionarProprietarioDialog.vue?vue&type=script&lang=js&"
export * from "./SelecionarProprietarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports